import React from "react";
import FluidImage from "../images/fluid-image";
import { AvailablePaymentMethod } from "@/networking/carts.api";

export default function AlternatePaymentIcons({
  paymentMethod,
}: {
  paymentMethod: AvailablePaymentMethod;
}) {
  if (!paymentMethod.image_url) {
    return null;
  }

  const isExternalUrl =
    paymentMethod.image_url.startsWith("http://") ||
    paymentMethod.image_url.startsWith("https://");

  if (isExternalUrl) {
    return (
      <img
        src={paymentMethod.image_url}
        alt={paymentMethod.name || paymentMethod.type}
        width={30}
        height={20}
        style={{ objectFit: "contain" }}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    );
  }

  return (
    <FluidImage
      src={paymentMethod.image_url}
      alt={paymentMethod.name || paymentMethod.type}
      width={30}
      height={20}
    />
  );
}
